import React from "react";
import { connect } from "react-redux";

const mapState = (state) => {
	return {
		"poliza": state.polizas.poliza
	};
};

class AseguradoPoliza extends React.Component {
	render() {
		let imgAsegurados, aAsegurados = [];
		let grupo = (this.props.poliza.generales.cveClasificacionSeguro == "06" || this.props.poliza.generales.cveClasificacionSeguro == "05");

		switch (this.props.poliza.generales.cveRamo) {
		case "G":
			imgAsegurados = require("../img/circle-contratante.svg");
			break;
		case "V":
			imgAsegurados = require("../img/circle-contratante.svg");
			break;
		}

		if (this.props.poliza.asegurados && this.props.poliza.asegurados.length > 0) {
			aAsegurados = this.props.poliza.asegurados;

			aAsegurados = aAsegurados.sort(function(a,b){ return b.banderaTitular.toString().localeCompare(a.banderaTitular.toString()); });
		}

		return <div>
			{ aAsegurados.map((item, i) =>
				<div className="col-xs-12" key={i}>
					<div className="row">
						<div className="col-xs-12">
							<div className="card perfil-card" style={{ "marginTop": "15px" }}>
								<i><img src={ imgAsegurados } alt="" className="pad-right-10" /></i><span className="blue-text detalle-seccion">Asegurado { (item.banderaTitular == 1 && this.props.poliza.generales.cveRamo == "G") ? (" Titular") : ("") }</span>
								<div className="row">
									<div className="col-md-6 col-xs-12">
										<ul className="list-divider mt-25">
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Nombre</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name={"asegnombre" + i}>{ item.nombres } { item.apellidoPaterno } { item.apellidoMaterno }</p>
													</div>
												</div>
											</li>
											<li className="clearfix">
												<div className="pull-left">
													<p><b>RFC</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name={"asegrfc" + i}>{ item.rfc }</p>
													</div>
												</div>
											</li>
											<li className="clearfix">
												<div className="pull-left">
													<p><b>CURP</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name={"asegcurp" + i}>{ item.curp }</p>
													</div>
												</div>
											</li>
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Género</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name={"aseggenero" + i}>{ (item.cveSexo) ? ((item.cveSexo == "M") ? ("Masculino") : ("Femenino")) : ("") }</p>
													</div>
												</div>
											</li>
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Fecha de nacimiento</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name={"asegfchnacimiento" + i}>{ item.fchNacimiento }</p>
													</div>
												</div>
											</li>
											{ item.certificado && grupo &&
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Certificado</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name={"asegcertificado" + i}>{ item.certificado }</p>
													</div>
												</div>
											</li>
											}
											{ !grupo &&
											<div>
												<li className="clearfix">
													<div className="pull-left">
														<p><b>Teléfono</b></p>
													</div>
													<div className="pull-right">
														<div className="gray-text texto15">
															{ item.medioContacto && item.medioContacto.telefono && item.medioContacto.telefono.length > 0 &&
															<p name={"asegtelefono" + i}>{ item.medioContacto.telefono[0] }</p>
															}

														</div>
													</div>
												</li>
												<li className="clearfix">
													<div className="pull-left">
														<p><b>Estado / Ciudad</b></p>
													</div>
													<div className="pull-right">
														<div className="gray-text texto15">
															{ item.direccion && item.direccion.length > 0 &&
															<p name={"asegEstado" + i}>{ item.direccion[0].estado }</p>
															}

														</div>
													</div>
												</li>
											</div>
											}
											{ grupo && this.props.poliza.generales.cveRamo == "G" &&
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Antigüedad GNP Nacional</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name={"asegantgnp" + i}>{ item.fchAntiguedadGnpNac }</p>
													</div>
												</div>
											</li>
											}
											{ grupo && this.props.poliza.generales.cveRamo == "G" &&
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Antigüedad GNP Internacional</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name={"asegantgnpint" + i}>{ item.fechaAntiguedadGnpInt }</p>
													</div>
												</div>
											</li>
											}
										</ul>
									</div>
									<div className="col-md-6 col-xs-12">
										<ul className="list-divider mt-25">
											{ !grupo &&
											<div>
												<li className="clearfix">
													<div className="pull-left">
														<p><b>Dirección</b></p>
													</div>
													<div className="pull-right">
														<div className="gray-text texto15">
															{ item.direccion && item.direccion.length > 0 &&
															<p name={"asegdireccion" + i}>{ item.direccion[0].calle } </p>
															}

														</div>
													</div>
												</li>
												<li className="clearfix">
													<div className="pull-left">
														<p><b>Número Interior</b></p>
													</div>
													<div className="pull-right">
														<div className="gray-text texto15">
															{ item.direccion && item.direccion.length > 0 &&
															<p name={"asegnumInterior" + i}>{ item.direccion[0].numInt }</p>
															}
														</div>
													</div>
												</li>
												<li className="clearfix">
													<div className="pull-left">
														<p><b>Número exterior</b></p>
													</div>
													<div className="pull-right">
														<div className="gray-text texto15">
															{ item.direccion && item.direccion.length > 0 &&
															<p name={"asegnumExterior" + i}>{ item.direccion[0].numExt }</p>
															}
														</div>
													</div>
												</li>
												<li className="clearfix">
													<div className="pull-left">
														<p><b>Colonia</b></p>
													</div>
													<div className="pull-right">
														<div className="gray-text texto15">
															{ item.direccion && item.direccion.length > 0 &&
															<p name={"asegcolonia" + i}>{ item.direccion[0].colonia }</p>
															}
														</div>
													</div>
												</li>
												<li className="clearfix">
													<div className="pull-left">
														<p><b>Código postal</b></p>
													</div>
													<div className="pull-right">
														<div className="gray-text texto15">
															{ item.direccion && item.direccion.length > 0 &&
															<p name={"asegcodigoPostal" + i}>{ item.direccion[0].codPostal }</p>
															}
														</div>
													</div>
												</li>
												<li className="clearfix">
													<div className="pull-left">
														<p><b>Delegación / Municipio</b></p>
													</div>
													<div className="pull-right">
														<div className="gray-text texto15">
															{ item.direccion && item.direccion.length > 0 &&
															<p name={"asegdelegacionMunicipio" + i}>{ item.direccion[0].municipio }</p>
															}
														</div>
													</div>
												</li>
											</div>
											}    
											{ grupo && this.props.poliza.generales.cveRamo == "G" &&
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Antigüedad otras compañias Nacional</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name={"asegantotr" + i}>{ item.fchAntiguedadOtraNac }</p>
													</div>
												</div>
											</li>
											}
											{ grupo && this.props.poliza.generales.cveRamo == "G" &&
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Antigüedad otras compañias Internacional</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name={"asegantotrint" + i}>{ item.fchAntiguedadOtraInt }</p>
													</div>
												</div>
											</li>
											}
											{this.props.poliza.generales.cveRamo == "G" &&
												this.props.poliza.generales.cveSistema == "ECO" &&
												<li className="clearfix">
													<div className="pull-left">
														<p><b>Plan Comercial</b></p>
													</div>
													<div className="pull-right">
														<div className="gray-text texto15">
															<p name={"asegantotrint" + i}>{item.planComercial}</p>
														</div>
													</div>
												</li>
											}
											{this.props.poliza.generales.cveRamo == "G" &&
												this.props.poliza.generales.cveSistema == "ECO" &&
												<li className="clearfix">
													<div className="pull-left">
														<p><b>Círculo Médico</b></p>
													</div>
													<div className="pull-right">
														<div className="gray-text texto15">
															<p name={"asegantotrint" + i}>{item.circuloMedico}</p>
														</div>
													</div>
												</li>
											}
											{this.props.poliza.generales.cveRamo == "G" &&
												this.props.poliza.generales.cveSistema == "ECO" &&
												<li className="clearfix">
													<div className="pull-left">
														<p><b>Nivel Hospitalario</b></p>
													</div>
													<div className="pull-right">
														<div className="gray-text texto15">
															<p name={"asegantotrint" + i}>{item.categoriaHospital}</p>
														</div>
													</div>
												</li>
											}
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>;
	}
}

export default connect(mapState)(AseguradoPoliza);



// WEBPACK FOOTER //
// ./src/home/asegurado.cmpt.js